import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContractService } from '../services/contract.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-contract-request',
  templateUrl: './contract-request.component.html',
  styleUrls: ['./contract-request.component.scss']
})
export class ContractRequestComponent implements OnInit, OnDestroy {
  public accessRoles: any;
  public uuid:string='';
  private destroy$ = new Subject<void>();
  

  public selectedValue = "India";
  public defaultSecNccsLsm = "SEC";
  public selecteValueSecNccsLsm = [ "A", "B" ];
  public defaultSecNccsLsmSpan:number = 3;
  public selectedGender = "Both";
  public isInterlokingQuotaOn = false;
  public isResetForm = false;
  public quoteObj:any = [];
  public quoteObjSection:any = {};
  public previousRequest="";
  public sampleSize=0;
  public isSaveAndNext:boolean=false;
  public isSharedWithClient:boolean = false;
  public isDependentAutoSave:boolean = false;
  public contractDetails:any = {};

  public todayDate: any;
  
  // public isSaveAndNext:boolean=true;
  public gridTypeData = [];
  public gridTypeDataCopy = [[{"key":"center","label":"","type":"single-select","value":"center","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"show":true,"pct":40,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"show":true,"pct":60,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Rest","type":"text","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"pct":80,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"pct":80,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"show":true,"pct":60,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Rest","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Other","selectedValue":""}],[{"key":"center","label":"Total","type":"label","value":"center","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":true,"show":true,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Rest","type":"text","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Rest","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Other","selectedValue":""}]];
  

  constructor(public contractService: ContractService,
        public sanitization: DomSanitizer,
        private notifier:NotifierService,
        private router: Router,
        private activaterRoute:ActivatedRoute
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    this.contractService.contractUUid = this.uuid;
    this.gridTypeData = JSON.parse(JSON.stringify(this.gridTypeDataCopy));
     this.contractService.updateContractRelatedFieldEmitter
     .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if(this.uuid === data.id){
          this.updateRelatedFields(data.data);
        }
      })
      this.contractService.isReloadFormEmitter
      .subscribe((data) => {
        if(this.uuid === data.uuid){
          this.getForm();
        }
      })
   }
  ngOnDestroy(): void {
    this.contractService.cid = "";
    this.contractService.contractUUid = "";
    this.isSaveAndNext = false;
    // this.contractService.trinityWidgetData = [];
    // this.contractService.isShowDownload = true
    this.contractService.contractQuoteSavePayloadObject = {};
    this.contractService.contractQuoteSavePrevPayloadObject = "";
    this.contractDetails = {};
    this.contractService.access = {};
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.contractService.contractSaveId = this.uuid;
    let today = new Date();
    this.todayDate = new Date(today.getFullYear(), (today.getMonth()), today.getDate());
    this.getForm();
  }

  backToContractList(){
    this.contractService.backToTrack()
    // this.router.navigate(['/contract']);
  }

  onReset(){
    this.isResetForm = true;
    this.isInterlokingQuotaOn = false;
    this.gridTypeData = JSON.parse(JSON.stringify(this.gridTypeDataCopy));
    this.getForm();
  }

  getForm() {
    let query = this.uuid && this.uuid != "" ?{"uuid":this.uuid} : {};
    this.contractService.getContractForm(query).subscribe((result) => {
      if (result["status"] == 1) {
        this.quoteObj = result['data'];
        this.contractService.access = result['access'];
        if (this.uuid && this.uuid != '' && !this.isResetForm) {
          this.isSaveAndNext = false;
          this.getContractDetails();
        }else{
          this.isResetForm = false;
          this.isSaveAndNext = true;
          this.quoteObjSection = {};
          this.initQuoteObj();
        }
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }


  getContractDetails() {
    this.contractService.getContractDetails(this.uuid).subscribe((result) => {
      if (result["status"] == 1) {
        this.contractDetails = result['data'];
        this.contractService.cid = result["cid"];
        this.isSharedWithClient = result['shared_with_client'] ? result['shared_with_client'] : false;
        // this.contractService.isShowPreview = result["show_preview"]
        this.contractService.isShowPreview = result['show_preview'] ? result['show_preview'] : false;
        // this.contractService.trinityWidgetData = result.cost_misc	|| [];
        // if(result.cost_misc && result.cost_misc[0] && result.cost_misc[0].length){
        //   this.contractService.isPMFeasibilty = result.cost_misc[0].findIndex((item) => item.value == 'Sent to PM') > -1;
        // }  
        this.reAssignQuoteObj(result['data']); 
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })

  }

  initQuoteObj(){
    this.contractService.showDataSaving = false;
    this.quoteObj.forEach((field,index) => {
      this.quoteObjSection[field.group_label] = this.quoteObjSection[field.group_label] ? this.quoteObjSection[field.group_label] : {'values':[]};
      // this.quoteObjSection[field.group_label]["show"] = field.group_label == 'Basic Details' ? true : true;
      this.quoteObjSection[field.group_label]["show"] = field.group_label == 'Basic Details' ? true : false;
      field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' && field["selectedValue"] != 'null' ? field["selectedValue"] : field["selectedValue"] >= 0 ? field["selectedValue"] : "";
      if (field["type"] == 'toggle') {        
        field["selectedValue"] = field["key"] == "interlocking_quota" ? this.isInterlokingQuotaOn : field["selectedValue"] == '' ? false : field["selectedValue"];
      }else if (field["type"] == 'from-to' || field["type"] == 'from-to-date') {
        field["selectedValue"] = {from:"",to:""};
        // field["selectedValue"] = {from:field["value"]["from"],to:field["value"]["to"]};
      }else if (field["type"] == 'percent-term' || field["type"] == 'two_input-pct-term') {
        field["selectedValue"] = [{"percent":"","term":""}];
        this.parsePlaceholder(field);
        // field["selectedValue"] = {"percent":field["value"][0]["percent"],"term":field["value"][0]["term"]};
      }else if (field["type"] == 'grid') {
        field["selectedValue"] = this.gridTypeData;
      }else if (field["type"] == 'single-select' && field["disabled"]) {
        let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
        field["selectedValue"] = option && option["label"] ? option["label"] : "";
      }

      if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
       field["filteredValue"] = JSON.parse(JSON.stringify(field["value"])) ;
      }
      
      this.quoteObjSection[field.group_label]["values"].push(field);
    });
    // console.log(this.quoteObjSection);
    // this.onDependencyChangeInInterlokingQuota();
  }


  reAssignQuoteObj(data){
    this.contractService.showDataSaving = true;
    let quoteObjSectionCopy = {}
    let dependentFieldCheck = [];
    
    this.contractService.contractQuoteSavePayloadObject = {};
    this.quoteObj.forEach((field,index) => {
      quoteObjSectionCopy[field.group_label] = (quoteObjSectionCopy && quoteObjSectionCopy[field.group_label]) ? quoteObjSectionCopy[field.group_label] : {"values": []};
      quoteObjSectionCopy[field.group_label]["show"] = true;
      this.contractService.contractQuoteSavePrevPayloadObject = JSON.stringify(data);
      if (Object.keys(data).includes(field["id"] +'')) {
        // if (field['misc'] && field['misc']["auto_update"]) {
        //   this.contractService.contractQuoteSavePayloadObject[field["id"]] = data[field["id"]]["value"];
        // }
        field["selectedValue"] = data[field["id"]]["value"] != 'null' ? data[field["id"]]["value"] : "";
        if (field["type"] == 'grid') {
          this.gridTypeData = JSON.parse(field["selectedValue"]);
          field["selectedValue"] = this.gridTypeData;
        }else if (field["type"] == 'from-to') {
          field["selectedValue"] = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) : field["selectedValue"];
        }else if (field["type"] == 'from-to-date') {
          let selectedValue = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) : field["selectedValue"];
          field["selectedValue"] = {}
          field["selectedValue"]["from"] = new Date(selectedValue["from"]);
          field["selectedValue"]["to"] = new Date(selectedValue["to"]);
        }else if (field["type"] == 'percent-term' || field["type"] == 'two_input-pct-term') {
          field["selectedValue"] = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) : [{"percent":"","term":""}];
          this.parsePlaceholder(field);
        }else if (field["type"] == 'single-select-obj') {
          let selectedValue = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) :field["selectedValue"];
          field["selectedValue"] = (selectedValue && selectedValue !="") ? selectedValue["label"] :"";
        }else if (field["type"] == 'multi-select-obj') {
          let selectedValue = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) :field["selectedValue"];
          field["selectedValue"] = (selectedValue && selectedValue !="") ? selectedValue.map(item => {return item.id}) :"";
        }else if (field["type"] == 'multi-select') {
          field["selectedValue"] = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) :field["selectedValue"];
        }else if (field["type"] == 'toggle' && field["key"] == "interlocking_quota") {
          this.isInterlokingQuotaOn = field["selectedValue"] == '' ? false : field["selectedValue"];
        }
        if (field.key == "pitch_simulation" && field.id == 3) {
          this.contractService.isShowDownload = field.selectedValue == 'Create Simulation' ? false : true;
        }
        // if (field["dependent"] && field["dependent"]["to"] || (field["key"]=="gender" && field["selaectedValue"] != "")) {
        //   dependentFieldCheck.push(field);
        // }
        if (field["label"] == "Sample Size") {
          this.sampleSize = field.selectedValue;
        }
        if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
          // field["filteredValue"] = Object.values(field["value"]) ? Object.values(field["value"]) : []; 
          field["filteredValue"] = JSON.parse(JSON.stringify(field["value"])) ;
         }
        //  if (field["type"] == 'multi-select') {
        //  }
      }else{
        field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' && field["selectedValue"] != 'null' ? field["selectedValue"] : "";
        if (field["type"] == 'toggle') {
          // field["selectedValue"] = this.isInterlokingQuotaOn;
          field["selectedValue"] = field["key"] == "interlocking_quota" ? this.isInterlokingQuotaOn : field["selectedValue"] == '' ? false : field["selectedValue"];
        }else if (field["type"] == 'from-to' || field["type"] == 'from-to-date') {
          field["selectedValue"] = {from:"",to:""};
          // field["selectedValue"] = {from:field["value"]["from"],to:field["value"]["to"]};
        }else if (field["type"] == 'percent-term' || field["type"] == 'two_input-pct-term') {
          field["selectedValue"] = [{"percent":"","term":""}];
          this.parsePlaceholder(field);
        }else if (field["type"] == 'grid') {
          field["selectedValue"] = this.gridTypeData;
        }else if (field["type"] == 'single-select' && field["disabled"]) {
          let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
          field["selectedValue"] = option && option["label"] ? option["label"] : "";
          this.contractService.contractQuoteSavePayloadObject[field.id] = option && option["label"] ? option["label"] : "";
        }
        if (field["selectedValue"] == '' && field["selected_value"] != '') {
          field["selectedValue"] = (field["type"] == 'radio') ? field["selected_value"] : (typeof field["selected_value"] === 'string') ? JSON.parse(field["selected_value"]) : field["selected_value"];
        }
        if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
          // field["filteredValue"] = Object.values(field["value"]) ? Object.values(field["value"]) : []; 
          field["filteredValue"] = JSON.parse(JSON.stringify(field["value"])) ;
         }
        //  if (field["type"] == 'multi-select') {
        //  }
      }
      if (field["dependent"] && field["dependent"]["to"] || (field["key"]=="gender" && field["selaectedValue"] != "")) {
        dependentFieldCheck.push(field);
      }
      quoteObjSectionCopy[field.group_label]["values"].push(field);
    });
    // console.log("dependentFieldCheck ====>",dependentFieldCheck);
    this.quoteObjSection = JSON.parse(JSON.stringify(quoteObjSectionCopy));
    dependentFieldCheck.forEach((field) => {
      // this.onRadioChange(field,true);
      if (field.type == 'radio') {
        this.onRadioChange(field,true);
      }else{
        this.checkOtherDependent(field,true);
      }
    })
    if(this.isDependentAutoSave){
      this.isAnyChangeInContractSaveQuotePayload();
    }
    // this.onDependencyChangeInInterlokingQuota();
    console.log("quoteObjSection ====>",this.quoteObjSection);
  }

  parsePlaceholder(field:any) {
    try {
      field["placeholder"] = field["placeholder"] && typeof field["placeholder"] === 'string'
        ? JSON.parse(field["placeholder"])
        : field["placeholder"];
    } catch (e) {
      field["placeholder"] = field["placeholder"];
    }
  }


  onRadioChange(field, isReassign?:boolean){
    if(this.validateField(field)){
      let dependent = field.dependent ? field.dependent : null;
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to,field,field.selectedValue,isReassign);
      }
      if (isReassign) {
        // this.appendToQuoteObjPayload(field, true);
      }else{
        this.appendToQuoteObjPayload(field);
      }
    }
  }

  checkOtherDependent(field, isReassign?:boolean){
      let dependent = field.dependent ? field.dependent : null;
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to,field,field.selectedValue,isReassign);
      }
      if (isReassign) {
        // this.appendToQuoteObjPayload(field, true);
      }else{
        this.appendToQuoteObjPayload(field);
      }
  }

  // onDependencyChangeInInterlokingQuota(){
  //   this.gridTypeData.forEach((gridRow, rowIndex) => {
  //     gridRow.forEach((gridItem, cellIndex) => {
  //       if (this.isInterlokingQuotaOn) {
  //         if(gridItem.group_label == "Gender" || gridItem.group_label == "Other"){
  //           if (rowIndex == this.gridTypeData.length - 1) {
  //             gridItem.disabled = true;
  //             gridItem.selectedValue = gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //           }else{
  //             if (gridItem.group_label == "Gender" && gridItem.key == "rest") {
  //               gridItem.disabled = this.selectedGender == "Both" ? false : true;
  //               gridItem.placeholder = gridItem.disabled ? "NA" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //             }else if (gridItem.group_label == "Gender" && gridItem.key == "M") {
  //               gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Male" ? false : true;
  //               gridItem.placeholder = gridItem.disabled ? "NA" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //             }else if (gridItem.group_label == "Gender" && gridItem.key == "F") {
  //               gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Female" ? false : true;
  //               gridItem.placeholder = gridItem.disabled ? "NA" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //             }else{
  //               gridItem.disabled = false;
  //               gridItem.placeholder = "";
  //               gridItem.selectedValue = gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //             }
  //           }
  //         }
  //       }else{
  //         if(gridItem.group_label == "Gender" || gridItem.group_label == "Other"){
  //           if (rowIndex < this.gridTypeData.length - 1) {
  //             gridItem.disabled = true;
  //             // gridItem.placeholder = gridItem.disabled ? "Any" :"";
  //             // gridItem.selectedValue = gridItem.disabled ? "Any" :gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //             if (gridItem.group_label == "Gender" && gridItem.key == "rest") {
  //               let makeNA = this.selectedGender == "Both" ? false : true;
  //               gridItem.placeholder = makeNA ? "NA" :"Any";
  //               gridItem.selectedValue = makeNA ? "NA" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
  //             }else if (gridItem.group_label == "Gender" && gridItem.key == "M") {
  //               let makeNA = this.selectedGender == "Both" || this.selectedGender == "Male" ? false : true;
  //               gridItem.placeholder = makeNA ? "NA" :"Any";
  //               gridItem.selectedValue = makeNA ? "NA" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
  //             }else if (gridItem.group_label == "Gender" && gridItem.key == "F") {
  //               let makeNA =  this.selectedGender == "Both" || this.selectedGender == "Female" ? false : true;
  //               gridItem.placeholder = makeNA ? "NA" :"Any";
  //               gridItem.selectedValue = makeNA ? "NA" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
  //             }else{
  //               gridItem.placeholder = gridItem.disabled ? "Any" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "Any" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
  //             }
  //           }else{
  //             if (gridItem.group_label == "Gender" && gridItem.key == "rest") {
  //               gridItem.disabled = this.selectedGender == "Both" ? false : true;
  //               gridItem.placeholder = gridItem.disabled ? "NA" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA'? "" : gridItem.selectedValue;
  //             }else if (gridItem.group_label == "Gender" && gridItem.key == "M") {
  //               gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Male" ? false : true;
  //               gridItem.placeholder = gridItem.disabled ? "NA" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA'? "" : gridItem.selectedValue;
  //             }else if (gridItem.group_label == "Gender" && gridItem.key == "F") {
  //               gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Female" ? false : true;
  //               gridItem.placeholder = gridItem.disabled ? "NA" :"";
  //               gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA'? "" : gridItem.selectedValue;
  //             }else{
  //               gridItem.disabled = false;
  //               gridItem.placeholder = "";
  //               gridItem.selectedValue = gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
  //             }
  //           }
  //         }
  //       }
       
  //     });
  //   });
  // }


  appendToQuoteObjPayload(field, isReassign?:boolean){
    let id = field.id+"";
    this.contractService.contractQuoteSavePayloadObject[id] = field.selectedValue;
    if (field && field.misc && field.misc.auto_save && !isReassign && !this.isSaveAndNext) {
      this.isAnyChangeInContractSaveQuotePayload();
    }
  }

  isAnyChangeInContractSaveQuotePayload(){
    // this.removeBlankIDs();
    let currentPayload = this.contractService.contractQuoteSavePayloadObject;
    if(!this.contractService.contractQuoteSavePrevPayloadObject){
      this.contractService.contractQuoteSavePrevPayloadObject = JSON.stringify(currentPayload);
      this.contractService.saveContractQuotePayload();
    }else{
      if (JSON.stringify(currentPayload) != this.contractService.contractQuoteSavePrevPayloadObject) {
        this.contractService.contractQuoteSavePrevPayloadObject = JSON.stringify(currentPayload);
        this.contractService.saveContractQuotePayload();
      }
    }
  }

  removeBlankIDs(){}

  checkDependent(fields,currentField,selectedValue,isReassign?:boolean){
    if(fields && fields.length){
      let isAutoSave = false;
      fields.forEach(field => {
        let dependentToField = this.quoteObj.find((item) => item.id == field.id);
        // let targetGroupLabel = this.quoteObj.find((item) => item.id == validation.value)["group_label"];
        //   let targetField = this.quoteObjSection[targetGroupLabel]["values"].find((item) => item.id == validation.value);
        if(field.type && field.type == "condition"){
            let response = this.checkDependentCondition(field.condition,selectedValue);
            if(response){
              Object.keys(field).forEach((fKey) => {
                if(fKey != "id" && fKey != "value" && fKey != "type"  && fKey != "condition" && fKey != "auto_save") {
                  // dependentToField[fKey] = field[fKey];
                  if (fKey == "selectedValue" && field.auto_save) {
                    let id = field.id+"";
                    dependentToField[fKey] = field[fKey];
                    // dependentToField[fKey] = (this.contractDetails[currentField.id] && this.contractDetails[currentField.id].value && this.contractDetails[currentField.id].value == currentField['selectedValue'])? dependentToField[fKey] : field[fKey];
                    this.contractService.contractQuoteSavePayloadObject[id] = field.selectedValue;
                    isAutoSave = field.auto_save ? true : isAutoSave;
                  }else if(fKey == "selectedValue" && field.default) {
                    dependentToField[fKey] = (this.contractDetails[field.id] && this.contractDetails[field.id].value && isReassign) ? dependentToField[fKey] :field[fKey];
                  }else{
                    dependentToField[fKey] = field[fKey];
                  }
                }
              })
            }
        }else{
          if (field.value.includes(selectedValue)) {
            // console.log("field ====>",field);
            Object.keys(field).forEach((fKey) => {
              if(fKey != "id" && fKey != "value" && fKey != "type" && fKey != "condition" && fKey != "auto_save") {
                // dependentToField[fKey] = field[fKey];
                if (fKey == "selectedValue" && field.auto_save) {
                    let id = field.id+"";
                    
                    let isCurrentFieldChanged = (isReassign && this.contractDetails[currentField.id] && this.contractDetails[currentField.id].value && this.contractDetails[currentField.id].value == currentField['selectedValue']) ? false : true;
                    this.contractService.contractQuoteSavePayloadObject[id] = isCurrentFieldChanged ? field[fKey] : dependentToField[fKey];
                    isAutoSave = field.auto_save ? true : isAutoSave;
                    dependentToField[fKey] = isCurrentFieldChanged ? field[fKey] : dependentToField[fKey];

                    // isAutoSave = field.auto_save ? true : isAutoSave;
                    // this.contractService.contractQuoteSavePayloadObject[id] = field.selectedValue;
                    // dependentToField[fKey] = field[fKey];
                  }else if(fKey == "selectedValue" && field.default) {
                    dependentToField[fKey] = (this.contractDetails[field.id] && this.contractDetails[field.id].value && isReassign) ? dependentToField[fKey] :field[fKey];
                  }else{
                    dependentToField[fKey] = field[fKey];
                  }
                  // console.log("dependentToField ====>",dependentToField);
              }
            })
          }
        }

        // Setting values to actual field object in quoteObjSection
        this.quoteObjSection[dependentToField.group_label]["values"].forEach((fItem) => {
          if(fItem.id == field.id){
            Object.keys(field).forEach((fKey) => {
              if(fKey != "id" && fKey != "value" && fKey != "type"  && fKey != "condition") {
                fItem[fKey] = dependentToField[fKey];
              }
            })
          }
        })
      });
      // console.log("this.quoteObjSection ====>",this.quoteObjSection);
      if (isAutoSave && !isReassign) {
        this.isAnyChangeInContractSaveQuotePayload();
      }else if (isAutoSave && isReassign) {
        this.isDependentAutoSave = true;
      }
    }
  }

  checkDependentCondition(fieldCodition:any,selectedValue){
    let isValid = false;
    selectedValue = selectedValue == null ? "" : selectedValue;
    if (fieldCodition.type == "equal-to" && selectedValue == fieldCodition.value) {
      isValid = true;
    }else if (fieldCodition.type == "not-equal-to" && selectedValue != fieldCodition.value) {
      isValid = true;
    }
    return isValid;
  }

  onInputFiledFocusOut(field:any){
    let value = field.selectedValue + "";
    if(this.validateField(field)){
      if(value == '' && field.required){
        this.notifier.notify('error',field.label + ' is required !');
      }else{
        if (field.dependent && field.dependent.to) {
          this.checkDependent(field.dependent.to,field,field.selectedValue,false);
        }
        this.appendToQuoteObjPayload(field);
      }
    }
  }

  onTwoInputPctTermFocusOut(field:any,rIndex){
    let id = field.id+"";
    if (field && field.selectedValue  && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
      this.contractService.contractQuoteSavePayloadObject[id] = [];
      this.contractService.contractQuoteSavePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
      if (field && field.misc && field.misc.auto_save) {
        field['error'] = false;
        // console.log("onTwoInputPctTermFocusOut ====>",this.contractService.contractQuoteSavePayloadObject);
        this.isAnyChangeInContractSaveQuotePayload();
      }
    }
  }

  onPercentTermFocusOut(field:any,rIndex){
    let id = field.id+"";
    if (field && field.selectedValue  && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
      this.contractService.contractQuoteSavePayloadObject[id] = [];
      this.contractService.contractQuoteSavePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
      if (field && field.misc && field.misc.auto_save) {
        field['error'] = false;
        this.isAnyChangeInContractSaveQuotePayload();
      }
    }
  }

  onSelectChangePercentTerm(field,option,rIndex){
    let id = field.id+"";
    if (field && field.selectedValue  && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
      this.contractService.contractQuoteSavePayloadObject[id] = [];
      this.contractService.contractQuoteSavePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
      if (field && field.misc && field.misc.auto_save) {
        field['error'] = false;
        this.isAnyChangeInContractSaveQuotePayload();
      }
    }
  }

   validateField(field:any){
    let isValid = true;

    if (field && field.required && field.show && !field.disabled) {
          if (field.type == 'from-to') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          }else if (field.type == 'percent-term' || field.type == 'two_input-pct-term') {
            if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item =>{ return item.percent == "" || item.term == ""})) {
              isValid = false;
            }
            // if (field.selectedValue && (field.selectedValue.length < 1 || field.selectedValue[0]["percent"] == "" || field.selectedValue[0]["term"] == "")) {
            //   isValid = false;
            // }
          }else{
            field.selectedValue = typeof field.selectedValue  === 'string' ? field.selectedValue.trim() : field.selectedValue;
            if(field.selectedValue == "" || field.selectedValue == null){
              isValid = false;
            }
          }
          if(!isValid){
            field['error'] = true;
            this.notifier.notify('error',field.label + ' is required !');
            return isValid;
          }else{
            field['error'] = false;
          }
        }
    if (field && field.show && field.validation && field.validation.length) {
      // console.log("field.validation ====>",field.validation);
      for(const validation of field.validation){
        if (validation.type == "regex") {
          if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
            const regex = new RegExp(validation.value);
            isValid = regex.test(field.selectedValue);
            if (!isValid) {
              this.notifier.notify('error',validation.message);
              isValid = false;
              break;
              // return isValid;
            }
          }
        }else if (validation.type == "total-invoicing-sum") {
          let totalInvoicing = 0;
          field.selectedValue.forEach((item) => {
            totalInvoicing += item.percent ? parseFloat(item.percent) : 0;
            // totalInvoicing += item.percent ? parseInt(item.percent) : 0;
          });
          console.log("totalInvoicing ====>",totalInvoicing);
          if (totalInvoicing != validation.value) {
            this.notifier.notify('error',validation.message);
            isValid = false;
            break;
            // return isValid;
          }
        }else if (validation.type == "age-range") {
          if (field.selectedValue["from"] && field.selectedValue["from"] != "" && field.selectedValue["to"] && field.selectedValue["to"] != "") {
            if (!(parseInt(field.selectedValue["from"]) <= parseInt(field.selectedValue["to"]))) {
              isValid = false;
              this.notifier.notify('error',validation.message);
              break;
              // return isValid;
            }
          }

        }else if (validation.type == "date-range-between") {
          let targetGroupLabel = this.quoteObj.find((item) => item.id == validation.value)["group_label"];
          let targetField = this.quoteObjSection[targetGroupLabel]["values"].find((item) => item.id == validation.value);
          if(!targetField.selectedValue["from"] || targetField.selectedValue["from"] == ""){
              this.notifier.notify('error',"Please enter date range for " + targetField.label);
              isValid = false;
              break; 
          }else if(!targetField.selectedValue["to"] || targetField.selectedValue["to"] == ""){
              this.notifier.notify('error',"Please enter date range for " + targetField.label);
              isValid = false;
              break;
          }
          // Parse dates safely and compare ranges
          const parseDate = (d: any) => d instanceof Date ? d : new Date(d);
          const targetFrom = parseDate(targetField.selectedValue["from"]);
          const targetTo = parseDate(targetField.selectedValue["to"]);
          const fieldFrom = parseDate(field.selectedValue["from"]);
          const fieldTo = parseDate(field.selectedValue["to"]);
          if (field.selectedValue["from"] && field.selectedValue["to"]) {
            // Ensure fieldFrom is not before targetFrom and fieldTo is not after targetTo
            if (fieldFrom < targetFrom || fieldTo > targetTo) {
              isValid = false;
              this.notifier.notify('error', validation.message);
              break;
            }
          }
        }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
          let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
          if (selectedValue > validation.value) {
            this.notifier.notify('error',validation.message);
            isValid = false;
            break;
            // return isValid;
          }
        }
      }
    
      if(!isValid){
        field['error'] = true;
      }else{  
        field['error'] = false;
      }
      return isValid;
    }else{
      field['error'] = false;
      return true;
    }
  }

  validateFullForm(){
    let isFormValid = true;
    for(const sectionKey in this.quoteObjSection){
      for(const field of this.quoteObjSection[sectionKey]["values"]){
        if (field && field.required && this.quoteObjSection[sectionKey].show && field.show && !field.disabled) {
          let isValid = true;
          if (field.type == 'from-to') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          }else if (field.type == 'from-to-date') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          }else if (field.type == 'percent-term' || field.type == 'two_input-pct-term') {
            if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item =>{ return item.percent == "" || item.term == ""})) {
              isValid = false;
            }
            // if (field.selectedValue && field.selectedValue.length < 2 && field.selectedValue[0]["percent"] == "") {
            //   isValid = false;
            // }
          }else{
            field.selectedValue = typeof field.selectedValue  === 'string' ? field.selectedValue.trim() : field.selectedValue;
            if(field.selectedValue == "" || field.selectedValue == null){
              isValid = false;
            }
          }
          if(!isValid){
            field['error'] = true;
            this.notifier.notify('error',field.label + ' is required !');
            isFormValid = false;
            break;
          }else{
            field['error'] = false;
          }
        }
        if (field && this.quoteObjSection[sectionKey].show && field.show && field.validation && field.validation.length) {
          let isValid = true;
          if (!field.required  && field.selectedValue == "") {
            isValid = true;
          }else{
            for(const validation of field.validation){
              if (validation.type == "regex") {
                if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
                  const regex = new RegExp(validation.value);
                  isValid = regex.test(field.selectedValue);
                  if (!isValid) {
                    this.notifier.notify('error',validation.message);
                    isValid = false;
                    break;
                    // return isValid;
                  }
                }
              }else if (validation.type == "total-invoicing-sum") {
                let totalInvoicing = 0;
                field.selectedValue.forEach((item) => {
                  totalInvoicing += item.percent ? parseFloat(item.percent) : 0;
                });
                console.log("totalInvoicing in full form ====>",totalInvoicing);
                if (totalInvoicing != validation.value) {
                  this.notifier.notify('error',validation.message);
                  isValid = false;
                  break;
                  // return isValid;
                }
              }else if (validation.type == "date-range-between") {
                let targetGroupLabel = this.quoteObj.find((item) => item.id == validation.value)["group_label"];
                let targetField = this.quoteObjSection[targetGroupLabel]["values"].find((item) => item.id == validation.value);
                if(!targetField.selectedValue["from"] || targetField.selectedValue["from"] == ""){
                    this.notifier.notify('error',"Please enter date range for " + targetField.label);
                    isValid = false;
                    break; 
                }else if(!targetField.selectedValue["to"] || targetField.selectedValue["to"] == ""){
                    this.notifier.notify('error',"Please enter date range for " + targetField.label);
                    isValid = false;
                    break;
                }
                // Parse dates safely and compare ranges
                const parseDate = (d: any) => d instanceof Date ? d : new Date(d);
                const targetFrom = parseDate(targetField.selectedValue["from"]);
                const targetTo = parseDate(targetField.selectedValue["to"]);
                const fieldFrom = parseDate(field.selectedValue["from"]);
                const fieldTo = parseDate(field.selectedValue["to"]);
                if (field.selectedValue["from"] && field.selectedValue["to"]) {
                  // Ensure fieldFrom is not before targetFrom and fieldTo is not after targetTo
                  if (fieldFrom < targetFrom || fieldTo > targetTo) {
                    isValid = false;
                    this.notifier.notify('error', validation.message);
                    break;
                  }
                }
              }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
                let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
                if (selectedValue > validation.value) {
                  this.notifier.notify('error',validation.message);
                  isValid = false;
                  break;
                  // return isValid;
                }
              }
            }
           
          }
          if(!isValid){
            field['error'] = true;
            isFormValid = false;
            break;
          }else{
            field['error'] = false;
          }
          // return isValid;
        }
      }
      if(!isFormValid){
        break;
      }
    }
    // console.log("quoteObjSection ====>",this.quoteObjSection);
    return isFormValid;
  }

  addPercentTerm(field){
    field.selectedValue.push({"percent":"","term":""});
  }

  checkSubLabel(sub_label){
    let subLabel = sub_label && sub_label !=null ? sub_label.trim() : '';
    return (subLabel && subLabel != '') ?true : false;
  }

  removePercentTerm(field,rIndex){
    field.selectedValue.splice(rIndex,1);
    this.contractService.contractQuoteSavePayloadObject[field.id+""] = JSON.parse(JSON.stringify(field.selectedValue));
    if(field.selectedValue.length < 1 ){
      field.selectedValue.push({"percent":"","term":""});
    }
  }
  onSelectChange(selectCtrl:MatSelect,field:any){
      if(this.validateField(field)){
        if (field && field.misc && field.misc.form_reload) {
          this.contractService.isFormReload = true;
        }
        this.appendToQuoteObjPayload(field);
      }
    }

    onObjSelectChange(selectedObjOption,field:any){
      if(this.validateField(field)){
        let id = field.id+"";
        if(!this.contractService.contractQuoteSavePayloadObject[id]){
          this.contractService.contractQuoteSavePayloadObject[id] = {};
        }else{
          this.contractService.contractQuoteSavePayloadObject[id] = typeof this.contractService.contractQuoteSavePayloadObject[id]  === 'string' ? JSON.parse(this.contractService.contractQuoteSavePayloadObject[id]) : this.contractService.contractQuoteSavePayloadObject[id];
        }
        this.contractService.contractQuoteSavePayloadObject[id]["label"] = selectedObjOption.value.label;
        this.contractService.contractQuoteSavePayloadObject[id]["id"] = selectedObjOption.key;
        if (field && field.misc && field.misc.form_reload) {
          this.contractService.isFormReload = true;
        }
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

    onMultiObjSelectChange(field:any){
      if(this.validateField(field)){
        let id = field.id+"";
        if(id && id == "27"){
          if (field.selectedValue && field.selectedValue.length > 1 && field.selectedValue.includes('pan')) {
            field.selectedValue = ['pan'];
            this.notifier.notify('warning','Can not select any center if Pan India is selected !');
            // return;
          }
        }
        this.contractService.contractQuoteSavePayloadObject[id] = [];
        field.selectedValue.forEach((selectedKey) => {
          this.contractService.contractQuoteSavePayloadObject[id].push({"id":selectedKey,"label":field.value[selectedKey].label});
        })      
        if (field && field.misc && field.misc.form_reload) {
          this.contractService.isFormReload = true;
        }
        if (field && field.misc && field.misc.form_reload) {
          this.contractService.isFormReload = true;
        }
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

    onSelectChangeForFromTo(field,option,type){
      if(this.validateField(field)){
        let id = field.id+"";
        if(!this.contractService.contractQuoteSavePayloadObject[id]){
          this.contractService.contractQuoteSavePayloadObject[id] = {};
        }else{
          this.contractService.contractQuoteSavePayloadObject[id] = typeof this.contractService.contractQuoteSavePayloadObject[id]  === 'string' ? JSON.parse(this.contractService.contractQuoteSavePayloadObject[id]) : this.contractService.contractQuoteSavePayloadObject[id];
        }
        this.contractService.contractQuoteSavePayloadObject[id][type] = option.value.label;
        if (type == "from" && !(this.contractService.contractQuoteSavePayloadObject[id]["to"] && this.contractService.contractQuoteSavePayloadObject[id]["to"] != "")) {
          this.contractService.contractQuoteSavePayloadObject[id]["to"] = field.selectedValue.to;
        }else if (type == "to" && !(this.contractService.contractQuoteSavePayloadObject[id]["from"] && this.contractService.contractQuoteSavePayloadObject[id]["from"] != "")) {
          this.contractService.contractQuoteSavePayloadObject[id]["from"] = field.selectedValue.from;
        }
  
        if (field && field.misc && field.misc.auto_save && this.contractService.contractQuoteSavePayloadObject[id]["from"] && this.contractService.contractQuoteSavePayloadObject[id]["from"] != "" && this.contractService.contractQuoteSavePayloadObject[id]["to"] && this.contractService.contractQuoteSavePayloadObject[id]["to"] != "") {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

    getDateStr(date: Date): string {
      let selectedDate = new Date(date);
      let selectedDateDay = selectedDate.getDate();
      let selectedDateMonth = selectedDate.getMonth() + 1; // Months are zero-based in JavaScript
      let selectedDateYear = selectedDate.getFullYear();
      return selectedDateYear+'-'+ selectedDateMonth+'-'+ selectedDateDay;
    }

    onDateChangeFromTo(field,type){
      if(this.validateField(field)){
        let id = field.id+"";
        if(!this.contractService.contractQuoteSavePayloadObject[id]){
          this.contractService.contractQuoteSavePayloadObject[id] = {};
        }else{
          this.contractService.contractQuoteSavePayloadObject[id] = typeof this.contractService.contractQuoteSavePayloadObject[id]  === 'string' ? JSON.parse(this.contractService.contractQuoteSavePayloadObject[id]) : this.contractService.contractQuoteSavePayloadObject[id];
        }

        if(field.selectedValue && field.selectedValue["to"] && field.selectedValue["to"] !='' && field.selectedValue["from"] && field.selectedValue["from"] !='' && new Date(field.selectedValue["to"]) < new Date(field.selectedValue["from"])){
          this.notifier.notify('error','To date should be greater than From date !');
          // field.selectedValue[type] = "";
          return;
        }

        this.contractService.contractQuoteSavePayloadObject[id][type] = this.getDateStr(field.selectedValue[type]);

        if (type == "from" && !(this.contractService.contractQuoteSavePayloadObject[id]["to"] && this.contractService.contractQuoteSavePayloadObject[id]["to"] != "") && field.selectedValue["to"] && field.selectedValue["to"] != "") {
          this.contractService.contractQuoteSavePayloadObject[id]["to"] = this.getDateStr(field.selectedValue["to"]);
          // this.contractService.contractQuoteSavePayloadObject[id]["to"] = selectedDate.getFullYear()+'-'+ selectedDate.getMonth()+'-'+ selectedDate.getDate();
        }else if (type == "to" && !(this.contractService.contractQuoteSavePayloadObject[id]["from"] && this.contractService.contractQuoteSavePayloadObject[id]["from"] != "") && field.selectedValue["from"] && field.selectedValue["from"] != "") {
          this.contractService.contractQuoteSavePayloadObject[id]["from"] = this.getDateStr(field.selectedValue["from"]);
          // this.contractService.contractQuoteSavePayloadObject[id]["from"] = selectedDate.getFullYear()+'-'+ selectedDate.getMonth()+'-'+ selectedDate.getDate();
        }
        if (field && field.misc && field.misc.auto_save && this.contractService.contractQuoteSavePayloadObject[id]["from"] && this.contractService.contractQuoteSavePayloadObject[id]["from"] != "" && this.contractService.contractQuoteSavePayloadObject[id]["to"] && this.contractService.contractQuoteSavePayloadObject[id]["to"] != "") {
          this.isAnyChangeInContractSaveQuotePayload();
        }

      }
      // let selectedDate = new Date(field.selectedValue[type]);
      // field.selectedValue[type] = selectedDate.getFullYear()+'-'+ selectedDate.getMonth()+'-'+ selectedDate.getDate()
    }

    getMinDate(field:any, type?:string){
      if (type && type == 'to' && field && field.selectedValue && field.selectedValue.from && field.selectedValue.from != "") {
        return new Date(field.selectedValue.from);
      }else{
        if (field && field.misc && field.misc.min_date  && field.misc.min_date == 'today') {
          // let today = new Date();
          // return new Date(today.getFullYear(), (today.getMonth()), today.getDate());
          return new Date();
        }else if (field && field.misc && field.misc.min_date) {
          return new Date(field.misc.min_date);
        }else{
          return new Date();
        }
      }
    }

    onToggleChange(field){
      if(this.validateField(field)){
        if (field.key == "interlocking_quota") {
          this.isInterlokingQuotaOn = field.selectedValue;
          // this.onDependencyChangeInInterlokingQuota();
        }
        let id = field.id+"";
        this.contractService.contractQuoteSavePayloadObject[id] = field.selectedValue;
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

    toggleDropdown(index: number, select: MatSelect) {
      if (select.panelOpen) {
        select.close();
      } else {
        select.open();
      }
    }

    // onCenterChange(event,trIndex,centers,field){
    //   let selectedCenters = centers.filter((center) => event.value.includes(center.key));
      
    //   let maxQuotaLimit = {
    //     "gender": {
    //     "male": 0,
    //     "female": 0,
    //     "rest": 0
    //   },
    //   "sec": {
    //     "a": 0,
    //     "b": 0
    //   },
    //   "nccs": {
    //     "a": 0,
    //     "b": 0
    //   },
    //   "lsm": {
    //     "a": 0,
    //     "b": 0
    //   },
    //   // "max_in_center": 0,
    //   "sample": 0
    //   }
  
    //   selectedCenters.forEach((center) => {
    //     maxQuotaLimit["gender"]["male"] += center["gender"]["male"]
    //     maxQuotaLimit["gender"]["female"] += center["gender"]["female"]
    //     maxQuotaLimit["gender"]["rest"] += center["max_in_center"]
    //     maxQuotaLimit["sec"]["a"] += center["sec"]["a"]
    //     maxQuotaLimit["sec"]["b"] += center["sec"]["b"]
    //     maxQuotaLimit["nccs"]["a"] += center["nccs"]["a"]
    //     maxQuotaLimit["nccs"]["b"] += center["nccs"]["b"]
    //     maxQuotaLimit["lsm"]["a"] += center["lsm"]["a"]
    //     maxQuotaLimit["lsm"]["b"] += center["lsm"]["b"]
    //     maxQuotaLimit["other"] = {"rest":0}
    //     maxQuotaLimit["other"]["rest"] += center["max_in_center"]
    //     maxQuotaLimit["sample"] += center["max_in_center"]
    //   });
    //   this.setCentersQuotaLimit(maxQuotaLimit, trIndex)
    //   let id = field.id+"";
    //   this.contractService.contractQuoteSavePayloadObject[id] = field.selectedValue;
    //   this.isAnyChangeInContractSaveQuotePayload();
      
    // }

    // setCentersQuotaLimit(quotaLimit, rowIndex){
    //   this.gridTypeData[rowIndex].forEach((gridItem) => {
    //     if (gridItem.group_label == "Sample") {
    //       gridItem["maxValue"] = quotaLimit["sample"];
    //     }else if (gridItem.group_label == "Gender" && gridItem.key == "M") { 
    //       gridItem["maxValue"] = quotaLimit["gender"]["male"]
    //     }else if (gridItem.group_label == "Gender" && gridItem.key == "F") { 
    //       gridItem["maxValue"] = quotaLimit["gender"]["female"]
    //     }else if (gridItem.group_label == "Gender" && gridItem.key == "rest") { 
    //       gridItem["maxValue"] = quotaLimit["gender"]["rest"]
    //     }else if (gridItem.group_label == "Other" && gridItem.key == "A") { 
    //       gridItem["maxValue"] = quotaLimit[this.defaultSecNccsLsm.toLocaleLowerCase()]["a"]
    //     }else if (gridItem.group_label == "Other" && gridItem.key == "B") { 
    //       gridItem["maxValue"] = quotaLimit[this.defaultSecNccsLsm.toLocaleLowerCase()]["b"]
    //     }else if (gridItem.group_label == "Other" && gridItem.key == "rest") { 
    //       gridItem["maxValue"] = quotaLimit["other"]["rest"]
    //     }
    //   });
    // }

    // onQuotaItemFocusOut(item,itemIndex,rowIndex,field){
    //   field.selectedValue = this.gridTypeData;
    //   if (itemIndex == 1 && this.isInterlokingQuotaOn) {
    //     this.setDefaultQuoteBySampleSize(rowIndex, item);
    //   }
    //   if ((item.maxValue && Number(item.selectedValue) > item.maxValue)) {
    //     this.notifier.notify('error','This center allow maximun '+ item.maxValue + ' ' + item.value + ' !');
    //   }else if (rowIndex < this.gridTypeData.length - 1) {
    //     var totalSamplesaize = 0;
    //     this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue = itemIndex==1? this.sampleSize: "0";
    //     this.gridTypeData.forEach((gridRow,rIndex) => {
    //       if (rIndex != this.gridTypeData.length - 1) {
    //         gridRow.forEach((gridItem) => {
    //           if (gridItem.group_label == item.group_label && gridItem.key == item.key) {
    //             // gridItem.selectedValue = "0";
    //             if (itemIndex != 1) {
    //               this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue = Number(this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue) + Number(gridItem.selectedValue) + "";
    //             }else{
    //               totalSamplesaize += Number(gridItem.selectedValue);
    //             }
    //           }
    //         });
            
    //       }
    //     });
    //     let rowSample = 0;
    //     let rowGender = 0;
    //     let rowOther = 0;
        
    //     this.gridTypeData[rowIndex].forEach((gridItem) => {
    //       if (gridItem.group_label == "Sample") {
    //         rowSample = Number(gridItem.selectedValue);
    //       }else if (gridItem.group_label == "Gender"){
    //         let value = gridItem.selectedValue == '' || gridItem.selectedValue == 'NA' ? 0 : Number(gridItem.selectedValue);
    //         rowGender += value;
    //       }else if (gridItem.group_label == "Other"){
    //         rowOther += Number(gridItem.selectedValue);
    //       }
    //     })
    //     if (rowGender > rowSample) {
    //       this.notifier.notify('error','Total gender should not be greater than sample size  '+rowSample+'!');
    //     }else if (rowOther > rowSample) {
    //       this.notifier.notify('error','Total '+this.defaultSecNccsLsm+' should not be greater than sample size '+rowSample+'!');
    //     }
    //     let id = field.id+"";
    //     this.contractService.contractQuoteSavePayloadObject[id] = field.selectedValue;
    //     setTimeout(() =>{
    //       this.isAnyChangeInContractSaveQuotePayload();
    //     },10)
    //   }
  
    //   if (totalSamplesaize > this.sampleSize) {
    //     this.notifier.notify('error','Total sample size should not be greater than '+ this.sampleSize + ' !');
    //   }
    // }

    // setDefaultQuoteBySampleSize(rowIndex, item){
    //   let genderCheck = {"disabled":false,"label":""};
    //   this.gridTypeData[rowIndex].forEach((gridItem) => {
    //     if (gridItem.group_label == "Gender" && gridItem.show && gridItem.pct) {
    //       if (!gridItem.disabled) {
    //         let pctValue = (Number(item.selectedValue) * gridItem.pct) / 100;
    //         gridItem.selectedValue = pctValue;
    //       }else{
    //         genderCheck["disabled"] = true;
    //         genderCheck["label"] = gridItem.label;
    //       }
    //     }else if (gridItem.group_label == "Other" && gridItem.population_classification && gridItem.population_classification == this.defaultSecNccsLsm && gridItem.show && !gridItem.disabled && gridItem.pct) {
    //       let pct = gridItem.pct;
  
    //       if(this.defaultSecNccsLsm == "LSM"){
    //         if(gridItem.label == "8-11"){
    //           pct = this.selecteValueSecNccsLsm.length == 1 ? 100 : this.selecteValueSecNccsLsm.length == 2 ? 80 : this.selecteValueSecNccsLsm.length == 3 ? 60 : gridItem.pct;
    //         }else{
    //           pct = this.selecteValueSecNccsLsm.length == 1 ? 100 : 20;
    //         }
    //       }else{
    //         pct = this.selecteValueSecNccsLsm.length == 1 ? 100 : gridItem.pct;
    //       }
    //       let pctValue = (Number(item.selectedValue) * pct) / 100;
    //       // let pctValue = (Number(item.selectedValue) * gridItem.pct) / 100;
    //       gridItem.selectedValue = pctValue;
    //     }
    //   });
    //   this.selecteValueSecNccsLsm
  
    //   if (genderCheck["disabled"]) {
    //     if (genderCheck["label"] == "M") {
    //       this.gridTypeData[rowIndex][3].selectedValue = (Number(item.selectedValue) * 100) / 100;
    //     }else{
    //       this.gridTypeData[rowIndex][2].selectedValue = (Number(item.selectedValue) * 100) / 100;
    //     }
    //   }
    // }

    // onDeleteGridRow(trIndex){
    //   this.gridTypeData.splice(trIndex, 1);
      
    // }
  checkSection(){
    if (this.quoteObjSection && Object.keys(this.quoteObjSection).length) {
      return true;
    }else{
      return false;
    }
  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }

  checkDownloadable(){
    this.contractService.isShowDownload = this.quoteObjSection["GENERAL"]["values"].find((item) => item.id == 3).selectedValue == 'I have pitch ID' && this.quoteObjSection["GENERAL"]["values"].find((item) => item.id == 4).selectedValue != '' && this.quoteObjSection["GENERAL"]["values"].find((item) => item.id == 5).selectedValue != '' ? true : false;
  }

  onSaveAndNext(){
    if (this.validateFullForm()) {
      this.isSaveAndNext = false;
      this.isAnyChangeInContractSaveQuotePayload();
    }
  }


  updateRelatedFields(data: any) {
    Object.keys(this.quoteObjSection).forEach((groupKey) => {
      this.quoteObjSection[groupKey]['values'].forEach((fieldObj) => {
        if(Object.keys(data).includes(fieldObj['id'] +'')){
          fieldObj['selectedValue'] = data[fieldObj['id']]['value'];
          let isValid = this.validateField(fieldObj);
        }
      })
    })
  }

  onSaveAsDraft(){}
  onPreviewClick(){
    if(this.contractService.isShowPreview){
      this.contractService.contractSaveId = this.uuid;
      this.contractService.backTrack = "contract-request";
      this.router.navigate(['/contract/preview/'+this.uuid]);
    }else{
      this.notifier.notify('error','Generating a COS of more than 20 lakh is not allowed!');
    }
  }
  onSendForApproval(){  
    if (this.validateFullForm()) {
      this.contractService.onSendForApproval(this.uuid);
      this.router.navigate(['/contract/details/'+this.uuid]);

      // console.log("onSendForApproval called");
    }
  }
  onShareWithClient(){
    if (this.validateFullForm()) {
      let body = {"uuid":this.uuid, "navigateTo":"/contract/details/"+this.uuid};
      this.contractService.onShareWithClient(body);

      // console.log("onShareWithClient called");
    }
  }
  onDownloadClick(){}

  getGridStyle(type: string, field?:any) {
    if (type === 'grid') { // condition for the item to span both columns
      return { 'grid-column': 'span 2' };
    }
    if (field && field.misc && field.misc.span) {
      let spanObj = {}
      if (field.misc.span.column) {
        spanObj['grid-column'] = 'span ' + field.misc.span.column;
      }
      if (field.misc.span.row) {
        spanObj['grid-row'] = 'span ' + field.misc.span.row;
      }
      return spanObj;
    }
    return {};
  }

  ondropdownSearchChange(searchValue: string, field: any) {
    // searchValue.toLowerCase()
    if (searchValue && searchValue != '') {      
      let allvalue = JSON.parse(JSON.stringify(field["value"])) ;
      field["filteredValue"] = {};
      for (const key in allvalue) {
        const tenpObj = allvalue[key];
        if (tenpObj.label.toLowerCase().includes(searchValue.toLowerCase())) {
          field["filteredValue"][key] = tenpObj;
        }
      }
    }else{
      field["filteredValue"] = JSON.parse(JSON.stringify(field["value"]));
      // field["value"] = JSON.parse(JSON.stringify(field["allValue"]));
    }

  }

}
